export const CLIP_EMPTY = 'クリップ済みのアイテムはありません';

export enum ClipType {
  REPORT = 'report',
  POST = 'post',
}

export const COLUMN = 'COLUMN';
export const INTERN = {
  JP: 'インターン',
  EN: 'Intern',
} as const;

export enum ClipStatus {
  CLIPPED = 'clipped',
  UNCLIPPED = '',
}

export const ClipConstants = {
  REPORTS: 'ES・体験記',
  POSTS: '就活コラム',
  MANAGEMENT: 'クリップ管理',
  URL: {
    [ClipType.REPORT]: '/clip/reports',
    [ClipType.POST]: '/clip/posts',
  },
  TAB_NAME: {
    [ClipType.REPORT]: '体験記',
    [ClipType.POST]: 'コラム',
  },
  ROUNDED: {
    [ClipType.REPORT]: 'rounded-l-[5px]',
    [ClipType.POST]: 'rounded-r-[5px]',
  },
};

export const PAGE_MYPAGE = 'マイページ';

export enum PageTabType {
  NEW = 'new',
  FOLLOW = 'follow',
  CLIP = 'clip',
}

export enum PageTabStatus {
  ACTIVE = 'active',
  INACTIVE = '',
}

export const PageTabConstants = {
  NEW: '新着',
  FOLLOW: 'フォロー',
  CLIP: 'クリップ',
  URL: {
    [PageTabType.NEW]: '/',
    [PageTabType.FOLLOW]: '/mypage/favs/companies',
    [PageTabType.CLIP]: '/clip/reports',
  },
  TAB_NAME: {
    [PageTabType.NEW]: '新着',
    [PageTabType.FOLLOW]: 'フォロー',
    [PageTabType.CLIP]: 'クリップ',
  },
} as const;

export enum UserMeClipType {
  SELECTION_REPORT = 'selectionReport',
  ENTRY_SHEET = 'entrySheet',
  COMPANY_COLUMN = 'companyColumn',
  COLUMN = 'column',
}

export const SELECTION = 'selection';

export enum ResourceLinkType {
  ENTRY_SHEET = 'passed_es',
  SELECTION_REPORT = 'selection_reports',
  COLUMN = 'archives',
}
